<template>
  <div class="home">
    <section class="hero">
      <div class="hero-content">
        <h1>Lunchlytics</h1>
        <p class="subtitle">Privacy-focused Cafeteria Utilization Monitoring System</p>
        <div class="cta-buttons">
          <router-link to="/dashboard" class="btn btn-primary">Analytics Dashboard</router-link>
          <router-link to="/stats" class="btn btn-secondary">System Status Dashboard</router-link>
        </div>
      </div>
    </section>

    <section class="features">
      <div class="feature-card">
        <div class="icon">📊</div>
        <h2>Real-time Visualization</h2>
        <p>Monitors approximated count of cafeteria visitors.</p>
      </div>

      <div class="feature-card">
        <div class="icon">🔒</div>
        <h2>Privacy First</h2>
        <p>All data is anonymized at the source. No personal information is ever transmitted or stored.</p>
      </div>

      <div class="feature-card">
        <div class="icon">🧠</div>
        <h2>Predictive Insights</h2>
        <p>AI-powered predictions may help you avoid long waits and overcrowding. </p>
        <div class="coming-soon-banner">
          <h3>🚧 Under Construction</h3>
        </div>
      </div>
    </section>

    <section class="how-it-works">
      <h2>How It Works</h2>
      <div class="steps">
        <div class="step">
          <div class="step-number">1</div>
          <h3>Data Collection</h3>
          <p>Collectors passively listen for WiFi signals to count unique devices in an area.</p>
        </div>

        <div class="step">
          <div class="step-number">2</div>
          <h3>Secure Processing</h3>
          <p>Data is aggregated locally and only raw numbers are sent to our server.</p>
        </div>

        <div class="step">
          <div class="step-number">3</div>
          <h3>Insightful Analytics</h3>
          <p>The dashboard displays real-time data with predictive analysis based on meals of the day, historical data and current date.</p>
        </div>
      </div>
    </section>

    <section class="disclaimer">
      <h2>Disclaimer</h2>
      <p>This is a fun, exploratory project created for learning and experimentation.</p>
      <p>Due to a variety of factors such as mac randomisation, device dependent probing intervals, people carrying multiple or no wifi enabled devices, the accuracy of the data may not be high or reliable in all situations.</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>

.disclaimer {
  background-color: #3e3a0f;
  color: #facc15;
  padding: 30px 20px;
  text-align: center;
  font-size: 0.95rem;
  border-top: 1px solid #b45309;
  margin-top: 40px;
}

.disclaimer h2 {
  margin-bottom: 12px;
  font-size: 1.5rem;
  color: #fbbf24;
}

.hero {
  padding: 40px 20px;
  text-align: center;
}

.hero h1 {
  font-size: 2.8rem;
  color: #a3b82f; /* lighter corporate green */
  margin-bottom: 12px;
}

.subtitle {
  font-size: 1.4rem;
  color: #cbd5e1;
  margin-bottom: 24px;
}

.cta-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  user-select: none;
}

.btn-primary {
  background-color: #8dbc05;
  color: #121212;
}

.btn-primary:hover {
  background-color: #81a905;
}

.btn-secondary {
  background-color: #2f2f2f;
  color: #a0aec0;
  border: 1px solid #4a5568;
}

.btn-secondary:hover {
  background-color: #3a3a3a;
}

.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  padding: 30px 20px;
}

.feature-card {
  background-color: #2a2a2a;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  text-align: center;
}

.icon {
  font-size: 2.5rem;
  margin-bottom: 16px;
  color: #8dbc05;
}

.feature-card h2 {
  color: #cbd5e1;
  margin-bottom: 12px;
}

.feature-card p {
  color: #a0aec0;
}

.how-it-works {
  padding: 40px 20px;
  text-align: center;
  color: #cbd5e1;
}

.how-it-works h2 {
  font-size: 1.8rem;
  color: #cbd5e1;
  margin-bottom: 24px;
}

.steps {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 24px;
}

.step {
  flex: 1;
  min-width: 250px;
  max-width: 300px;
  color: #bbb;
}

.step-number {
  width: 36px;
  height: 36px;
  background-color: #8dbc05;
  color: #121212;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin: 0 auto 16px;
}

h3 {
  color: #cbd5e1;
  margin-bottom: 12px;
}

.step p {
  color: #a0aec0;
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 2.3rem;
  }

  .subtitle {
    font-size: 1.1rem;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }

  .btn {
    width: 100%;
    max-width: 300px;
    margin-bottom: 8px;
  }
}
</style>
